import { createSlice } from "@reduxjs/toolkit";
import { INotesHistory } from "../../pages/lab-hw/rack/details/notesHistory/type";

interface NotesHistoryState {
    data: INotesHistory[];
    pageSize: number;
    pageNumber: number;
    totalCount: number;
    showLoading: {
        sourceAction: string;
        state: boolean;
    };
    isLoading: boolean;
    isSuccess: boolean;
    details: INotesHistory | null;
}

const initialState: NotesHistoryState = {
    data: [],
    pageSize: 0,
    pageNumber: 0,
    totalCount: 0,
    showLoading: {
        sourceAction: "",
        state: false,
    },
    isLoading: false,
    isSuccess: false,
    details: null,
};

export const notesHistorySlice = createSlice({
    name: "notesHistory",
    initialState,
    reducers: {
        setLoading: (state, action) => {
            const { sourceAction, isLoading, isSuccess } = action.payload;
            state.showLoading = {
                sourceAction,
                state: true,
            };
            state.isLoading = !!isLoading;
            state.isSuccess = !!isSuccess;
        },

        resetLoading: (state, action) => {
            const { isLoading, isSuccess } = action.payload;
            state.showLoading = {
                sourceAction: "",
                state: false,
            };
            state.isLoading = !!isLoading;
            state.isSuccess = !!isSuccess;
        },

        replaceNotesHistory: (state, action) => {
            const { data, pageSize, pageNumber, totalCount } = action.payload;
            state.data = data;
            state.pageSize = pageSize;
            state.pageNumber = pageNumber;
            state.totalCount = totalCount;
        },

        addNotes: (state, action) => {
            const newItem = action.payload.data;
            if (Array.isArray(state.data) && state.pageSize > 0 && state.data.length >= state.pageSize) {
                state.data.pop();
            }
            state.data = state.data ? [newItem, ...state.data] : [newItem];
            state.totalCount += 1;
        },

        setNotesHistory: (state, action) => {
            state.details = action.payload.data;
        },
    },
});

export const notesHistoryAction = notesHistorySlice.actions;

export default notesHistorySlice.reducer;
